import LABELS from '../../../../pages/_react-admin/service-type/labels';

const SERVICES_CHOICES = Object.entries(LABELS.TYPES)
  .filter(([id]) => id !== 'SERVICE_TYPE_UNKNOWN')
  .map(([id, name]) => ({ id, name }));

export default SERVICES_CHOICES;
